import React, { useContext } from 'react'
import PropTypes, {
  arrayOf,
  bool,
  oneOfType,
  number,
  string,
  shape,
} from 'prop-types'
import * as Styled from './CooperationList.styles'
import { TextContext } from 'hocs'
import { Accordion, DetailLinkList } from 'components/molecules'
import { getReplacedString } from 'settings/app/helpers'
import { entryPointId } from 'settings/app/constants'

const Cooperation = ({ cooperation, open, linkTyp }) => {
  const textContext = useContext(TextContext)
  const { name, doctors, id } = cooperation

  return (
    <Styled.CooperationList data-cy={ `cooperation-${ id }` }>
      <div className='cooperation-header'>
        <span className='name'>{name}</span>
      </div>
      <Accordion
        label={ getReplacedString({
          search: textContext['cooperationList.accordion.Title'],
          replaceWith: doctors.length,
        }) }
        type={ 'ASV' }
        className='cooperation-list-accordion'
        open={ open }>
        <DetailLinkList isAsvList items={ doctors } linkTyp={ linkTyp } />
      </Accordion>
    </Styled.CooperationList>
  )
}

Cooperation.defaultProps = {
  open: true,
  linkTyp: entryPointId.DOCTORS,
}

Cooperation.propTypes = {
  cooperation: shape({
    name: string.isRequired,
    id: oneOfType([string, number]),
    label: string,
    doctors: arrayOf(
      shape({
        id: oneOfType([string, number]).isRequired,
        name: string.isRequired,
        label: string.isRequired,
        teamLeading: bool,
      })
    ).isRequired,
  }).isRequired,
  open: bool,
  /** used for distinction between hospitals or doctors link **/
  linkTyp: PropTypes.string,
}

export default Cooperation
